module.exports = __webpack_public_path__ + "img/zh_hk.af92fbd4.png";